<section class="chart-card">
    <header class="chart-header">
      <h2>{{title}}</h2>
      <p>Performance overview for the selected period</p>
    </header>
  
    <dl class="chart-list">
      <div
        class="chart-row"
        *ngFor="let item of data"
      >
        <dt class="month">
          {{ item.name }}
        </dt>
  
        <dd class="bar-wrapper">
          <div
            class="bar-bg"
            [class.bar-bg--highlight]="item.highlight"
          >
            <div
              class="bar-fill"
              [class.bar-fill--highlight]="item.highlight"
              [style.width.%]="item.percentage"
            ></div>
          </div>
  
          <span
            class="value"
            [class.value--highlight]="item.highlight"
          >
            {{ item.value | number }}
          </span>
        </dd>
      </div>
    </dl>
  
    <footer class="legend">
      <div class="legend-item">
        <span class="dot dot--standard"></span>
        <span>Standard</span>
      </div>
      <div class="legend-item">
        <span class="dot dot--highlight"></span>
        <span>Peak Month</span>
      </div>
    </footer>
  </section>
  